<template>
  <div class="flex flex-col gap-4">
    <div v-if="mission">
      <h4 class="text-title-medium mb-1">{{ $t('lumia.phase.studentsGoal') }}</h4>
      <div class="bg-primary-container rounded-medium p-3">
        <div class="text-on-primary-container mb-1 flex flex-row items-center gap-1">
          <BaseIcon size="20">rocket_launch</BaseIcon>
          <h4 class="text-title-small">{{ $t('lumia.sections.mission') }}</h4>
        </div>
        <LessonImpulseField class="text-body-large" :value="mission" />
      </div>
    </div>
    <div v-if="indicators.length > 0">
      <h4 class="text-title-medium mb-1">{{ $t('lumia.phase.formativeAssessment') }}</h4>
      <ul class="flex flex-col gap-0.5">
        <li
          v-for="indicator in indicators"
          :key="indicator.id"
          class="bg-surface-container-lowest rounded-extra-small first:rounded-t-medium last:rounded-b-medium px-3 py-1.5"
        >
          <span class="text-body-medium">{{ indicator.studentPhrasing }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import type { Indikator } from '../models/lesson-impulse.ts'
  import LessonImpulseField from './LessonImpulseField.vue'

  interface Props {
    mission: string | null
    indicators: ReadonlyArray<Indikator>
  }

  defineProps<Props>()
</script>
